export default __webpack_public_path__ + "static/media/onama.3b700320.jpg";